import React from 'react';
import './footer.css';

const Footer = () => {
    return (
        <div className="footer_con">
            Footer
        </div>
    );
};

export default Footer;